import qs from "qs";
import useConfig from "../hooks/useConfig";
import * as Storage from "../store/LocalStorage";
import axios from "axios";
import useAuth from "../hooks/useAuth";
import apiServices from "./ApiServices";

const badRespnseCodes = [401];
const versionPrefix = "api/v1";
let myClientId;
let myClientSecret;

export default function FetchServices() {
  const config = useConfig();
  myClientId = config?.clientId;
  myClientSecret = config?.clientSecret;
  let myAccessToken;
  let session = localStorage.getItem(config?.sessionKey);
  if (session) {
    let sessionObject = JSON.parse(session);
    let { accessToken } = sessionObject;
    myAccessToken = accessToken;
  }

  let { user } = useAuth();
  const AxiosService = ({
    API,
    payload,
    authNeeded = true,
    type = "POST",
    token,
    concurrencyStamp,
    refreshToken,
  }) => {
    let authData = {};
    if (authNeeded) {
      authData = {
        token: user?.token ?? token,
      };
    }
    let header = {
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      Authorization: authData.token,
      ...(concurrencyStamp
        ? { "x-coreplatform-concurrencystamp": concurrencyStamp }
        : {}),
      "client-id": config.clientId,
      "client-secret": config.clientSecret,
      refresh: refreshToken,
    };

    if (type === "GET") {
      header = {
        "content-type": "application/json",
        Authorization: authData.token,
        ...(concurrencyStamp
          ? { "x-coreplatform-concurrencystamp": concurrencyStamp }
          : {}),
        refresh: refreshToken,
      };
    }
    return axios({
      method: type,
      url: API,
      headers: header,
      params:
        type === "GET" || type === "DELETE"
          ? {
              ...payload,
            }
          : {},
      data: qs.stringify({
        ...payload,
      }),
    })
      .then(function (response) {
        var resData = response.data;
        let headers = response.headers;
        let totalCount =
          headers["x-coreplatform-total-records"] &&
          headers["x-coreplatform-total-records"];
        let publicId = headers["public-id"] && headers["public-id"];
        let fileName = headers["file-name"] && headers["file-name"];
        if (!resData) {
          const errorRes = {
            data: resData.data,
            code: resData.code,
            success: false,
            ...(totalCount ? { totalCount } : {}),
            ...(publicId ? { publicId } : {}),
            ...(fileName ? { fileName } : {}),
          };
          if (response.status === 201 || response.status === 204) {
            return {
              success: true,
              ...(totalCount ? { totalCount } : {}),
              ...(publicId ? { publicId } : {}),
              ...(fileName ? { fileName } : {}),
            };
          }
          if (authNeeded) {
            const sessionResp = checkSession(errorRes);
            return sessionResp;
          } else {
            return errorRes;
          }
        }
        const apiResponse = resData;
        return {
          status: true,
          data: apiResponse,
          success: true,
          ...(totalCount ? { totalCount } : {}),
          ...(publicId ? { publicId } : {}),
          ...(fileName ? { fileName } : {}),
        };
      })
      .catch(function (res) {
        if (
          res &&
          res?.response &&
          res?.response?.status &&
          badRespnseCodes.indexOf(res?.response?.status) > -1
        ) {
          checkResponseCode(res);
        }
        console.log(res);
        console.log("An error occurred in " + API + "  service");
        return {
          status: false,
          ...res?.response?.data,
        };
      });
  };

  const checkResponseCode = (data) => {
    Storage.clear();
    window.location.reload();
  };

  const checkSession = function (data) {
    let message = data.msg;

    if (typeof message === "string" || message instanceof String) {
      message = message ? message.toLowerCase() : "";
      message = message.trim();
      if (
        message === "id or token wrong." ||
        message === "email id or token wrong." ||
        message === "invalid signature"
      ) {
        const sessionKey = config.sessionKey;
        Storage.remove(sessionKey);
        window.location.reload();

        return { ...data, sessionExpired: true };
      }
    }

    return { ...data, sessionExpired: false };
  };

  const fetchData = async (
    API,
    details = {},
    tokenNeeded = false,
    clientDetailsNeeded = false,
    accessToken = null
  ) => {
    // Fetch token & client details only if needed
    const token =
      tokenNeeded && accessToken
        ? accessToken
        : tokenNeeded
        ? myAccessToken
        : null;
    const clientDetails = clientDetailsNeeded
      ? {
          clientId: myClientId,
          clientSecret: myClientSecret,
        }
      : null;

    // Construct headers dynamically
    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(clientDetails && {
        "client-id": clientDetails.clientId,
        "client-secret": clientDetails.clientSecret,
      }),
    };

    try {
      const response = await axios.get(API, {
        headers: headers,
        params: details, // Assuming details are query params
      });
      return response;
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        localStorage.removeItem(config?.sessionKey);
        window.location.reload();
      }
      throw error;
    }
  };

  const fetchDataById = async (
    API,
    tokenNeeded = false,
    clientDetailsNeeded = false
  ) => {
    // Fetch token & client details only if needed
    const token = tokenNeeded ? myAccessToken : null;
    const clientDetails = clientDetailsNeeded
      ? {
          clientId: myClientId,
          clientSecret: myClientSecret,
        }
      : null;

    // Construct headers dynamically
    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(clientDetails && {
        "client-id": clientDetails.clientId,
        "client-secret": clientDetails.clientSecret,
      }),
    };

    try {
      const response = await axios.get(API, {
        headers: headers,
      });
      return response;
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        localStorage.removeItem(config?.sessionKey);
        window.location.reload();
      }
      throw error;
    }
  };

  const postData = async (
    API,
    payload = {},
    tokenNeeded = false,
    clientDetailsNeeded = false,
    isFileUpload = false // New parameter to handle file uploads
  ) => {
    // Fetch token & client details only if needed
    const token = tokenNeeded ? myAccessToken : null;
    const clientDetails = clientDetailsNeeded
      ? {
          clientId: myClientId,
          clientSecret: myClientSecret,
        }
      : null;

    // Determine Content-Type dynamically
    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(clientDetails && {
        "client-id": clientDetails.clientId,
        "client-secret": clientDetails.clientSecret,
      }),
      ...(isFileUpload
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" }),
    };

    try {
      const response = await axios.post(API, payload, { headers });
      return response;
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        localStorage.removeItem(config?.sessionKey);
        window.location.reload();
      }
      console.error("Error in postData:", error);
      throw error;
    }
  };

  const patchData = async (
    API,
    payload = {},
    tokenNeeded = false,
    clientDetailsNeeded = false,
    isFileUpload = false,
    concurrencyStamp = null
  ) => {
    const token = tokenNeeded ? myAccessToken : null;
    const clientDetails = clientDetailsNeeded
      ? {
          clientId: myClientId,
          clientSecret: myClientSecret,
        }
      : null;

    let headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(clientDetails && {
        "client-id": clientDetails.clientId,
        "client-secret": clientDetails.clientSecret,
      }),
      ...(concurrencyStamp && {
        "x-coreplatform-concurrencystamp": concurrencyStamp,
      }),
      ...(isFileUpload
        ? { "Content-Type": "multipart/form-data" }
        : { "Content-Type": "application/json" }),
    };

    try {
      const response = await axios.patch(API, payload, { headers });
      return response;
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        localStorage.removeItem(config?.sessionKey);
        window.location.reload();
      }
      console.error("Error in patchData:", error);
      throw error;
    }
  };

  const deleteData = async (
    API,
    details = null,
    tokenNeeded = false,
    clientDetailsNeeded = false,
    concurrencyStamp = null
  ) => {
    const token = tokenNeeded ? myAccessToken : null;
    const clientDetails = clientDetailsNeeded
      ? {
          clientId: myClientId,
          clientSecret: myClientSecret,
        }
      : null;

    let headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(clientDetails && {
        "client-id": clientDetails.clientId,
        "client-secret": clientDetails.clientSecret,
      }),
      ...(concurrencyStamp && {
        "x-coreplatform-concurrencystamp": concurrencyStamp,
      }),
    };

    try {
      const response = await axios.delete(API, {
        headers,
        ...(details && { data: details }), // Include details if present
      });
      return response;
    } catch (error) {
      if (error?.response?.data?.status === 401) {
        localStorage.removeItem(config?.sessionKey);
        window.location.reload();
      }
      console.error("Error in deleteData:", error);
      throw error;
    }
  };

  return {
    AxiosService,
    fetchData,
    fetchDataById,
    postData,
    patchData,
    deleteData,
  };
}
